module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"statement":"Your information will be stored in accordance with our {link}.","linkText":"Privacy Policies"}}')
  delete Component.options._Ctor
}
